export default "__VITE_ASSET__630fe15b__"